// @ts-check

import { checkArrayOnlyType, checkStrings } from 'libs/types/checkTypes';
import createAddressObj from './createAddressObj';
import getAddressType from './getAddressType';
import USER_ADDRESS from 'constants/userAddress';

/**
 * @typedef {Object} ProfileUserAddressType
 * @property {string} address_id
 * @property {string} street
 * @property {string} city
 * @property {string} province
 * @property {string} postalCode
 * @property {string} country
 * @property {string} placeId
 * @property {string} type
 * @property {string} lat
 * @property {string} lng
 * @property {string} unit
 */

/**
 * @function updateAddresses
 * @param {string} name
 * @param {object} payload
 * @param {ProfileUserAddressType[]} addresses
 * @returns {ProfileUserAddressType[]}
 */
function updateAddresses(name, payload, addresses) {
	checkStrings(name);
	checkArrayOnlyType(addresses);

	const addressType = getAddressType(name);
	const foundAddress = addresses.find((address) => address.type === addressType);
	const addressObj = createAddressObj(foundAddress, payload, addressType);

	if (foundAddress) {
		return addresses.map((address) => (address.type === addressType ? addressObj : address));
	}

	return addresses;
}

/**
 * @function deleteAddresses
 * @param {string} payload Address Type
 * @param {ProfileUserAddressType[]} addresses User Addresses
 * @returns {ProfileUserAddressType[]}
 */
function deleteAddresses(payload, addresses) {
	checkStrings(payload);
	checkArrayOnlyType(addresses);

	const deletedAddresses = addresses.map((address) => {
		if (address[USER_ADDRESS.TYPE] === payload) {
			return {
				...address,
				address_id: '',
				type: address[USER_ADDRESS.TYPE],
				street: '',
				city: '',
				province: '',
				country: '',
				postalCode: '',
				placeId: '',
				lat: '',
				lng: '',
				unit: '',
			};
		}
		return { ...address };
	});

	return deletedAddresses;
}

export { updateAddresses, deleteAddresses };
